export default __webpack_public_path__ + "fdfc7b5a4cf44eab04cb03a56af0b19e.png";